module.exports = __webpack_public_path__ + "static/media/monitor.3c64c9f5.png";